import { Navigate, useParams } from 'react-router-dom';

/** 兼容旧路由 /schema-profiles/:profileId/design */
export function SchemaProfileDesignRedirect() {
  const { profileId } = useParams<{ profileId: string }>();
  return <Navigate to={`/schema-profiles/${profileId ?? ''}`} replace />;
}
